<section>
   <div *ngIf="!isNew && dataSrv.user.IsAdmin" class="inline-block" >
      <button *ngIf="!inEdit" mat-stroked-button color="primary" class="btn_edit"
              (click)="clickEditItem(true)">
         <mat-icon>edit</mat-icon> Modifica
      </button>
   </div>

   <div *ngIf="!isNew" class="inline-block">
      <button *ngIf="inEdit" mat-raised-button color="warn"
              (click)="clickEliminaItem()">
         <mat-icon>delete</mat-icon> Elimina
      </button>
   </div>

   <div *ngIf="!isNew && showSave" class="inline-block">
      <button *ngIf="inEdit" mat-raised-button color="warn-outline"
              (click)="clickSave()">
         <mat-icon>save</mat-icon> Salva
      </button>
   </div>

   <div *ngIf="!isNew" class="inline-block">
      <button *ngIf="inEdit" mat-stroked-button color="primary" class="btn_edit"
              (click)="clickEditItem(false)">
         <mat-icon>visibility</mat-icon> Visualizza
      </button>
   </div>

   <div *ngIf="isNew && showAdd" class="inline-block">
      <button mat-stroked-button class="btn_edit" color="warn"
              [disabled]="disabled"
              (click)="clickAddItem()">
         <mat-icon>add</mat-icon> Aggiungi
      </button>
   </div>
</section>
